import PropTypes from "prop-types";
import { experimentalStyled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import Sidebar from "./Sidebar";
import Header from "./Header";

const MainWrapper = experimentalStyled(Box)(
  ({ theme }) => `
        flex: 1 1 auto;
        display: flex;
        height: 100%;
        background: "#F2F6FF";
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            padding-left: ${theme.sidebar.width};
        }
`,
);

const MainContent = experimentalStyled(Box)(
  ({ theme }) => `
        margin-top: ${theme.header.height};
        flex: 1 1 auto;
        overflow: auto;
        padding: ${theme.spacing(4)}
`,
);

const SidebarLayout = ({ children }) => {
  const is_bo_admin_login = localStorage.getItem("is_bo_admin_login") || false;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {is_bo_admin_login && (
        <Box sx={{ flexShrink: 0, width: "100%" }}>
          <Typography
            fontWeight={500}
            sx={{
              color: "#fff",
              py: 0.5,
              background: "#FFA31A",
            }}
            fontSize={11}
            align="center"
          >
            This is a user-impersonated session. Please be careful..
          </Typography>
        </Box>
      )}
      <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
        <Sidebar />
        <MainWrapper>
          <Header />
          <MainContent>{children}</MainContent>
        </MainWrapper>
      </Box>
    </Box>
  );
};

SidebarLayout.propTypes = {
  children: PropTypes.node,
};

export default SidebarLayout;
